import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import {
  getCaseData,
  getEntityContext
} from 'app/infrastructure/ui/renderer/resolvers';
import { StoreData } from 'app/types-shared';
import { entityFilter } from 'app/area/case/entity-filters';
import { getStorePath } from 'app/infrastructure/store/path';
import { getEntityTypeFromPath } from 'app/infrastructure/store/entity';
import { getChildEntities, getById } from 'app/infrastructure/store/query';

const selectEntities = (
  entityTypePath: string[],
  caseState: CaseState,
  uiEngineProps: ConnectedComponentProps
) => {
  const entityType = getEntityTypeFromPath(entityTypePath);

  if (!entityType) {
    throw new Error(
      `Expected entityTypePath to be configured for component ${
        uiEngineProps.componentDescriptor.id
      }.`
    );
  }

  const caseData: StoreData = getCaseData(caseState, uiEngineProps);
  const entityContext = getEntityContext(caseState, uiEngineProps);
  const storePath = getStorePath(entityTypePath, entityContext.path);

  const storeEntities = getChildEntities(caseData, storePath, entityType);
  const filteredEntities = storeEntities.filter(e =>
    entityFilter(e, uiEngineProps)
  );

  return {
    childEntities: filteredEntities ? filteredEntities : []
  };
};

/**
 * Provide all store entities at a specific path.
 */

export const entities = (entityTypePath: string[]) => (
  caseState: CaseState,
  uiEngineProps: ConnectedComponentProps
) => {
  return selectEntities(entityTypePath, caseState, uiEngineProps);
};

/**
 * Provide all store child entities of the current component.
 */

export const childEntities = (
  caseState: CaseState,
  uiEngineProps: ConnectedComponentProps
) => {
  const entityTypePath = uiEngineProps.componentDescriptor.entityTypePath;

  return selectEntities(entityTypePath, caseState, uiEngineProps);
};

export const rowEntity = (
  caseState: CaseState,
  uiEngineProps: ConnectedComponentProps
) => {
  const caseData: StoreData = getCaseData(caseState, uiEngineProps);
  const entityContext = getEntityContext(caseState, uiEngineProps);
  return { rowEntity: getById(caseData, entityContext.path) };
};
